import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { useLocation, useParams } from "react-router-dom";
import { useDebounce } from "use-debounce";

import {
  Table,
  TableBody,
  TableFilter,
  TableHeader,
  TableSearch,
} from "../../../components/table";

import Checkbox from "../../../components/Checkbox/Checkbox";
import { LoadingSpinner } from "../../../components/Loader/Loader";
import http, { downloadUrl } from "../../../config/BaseUrl";
import LocalStorage from "../../../hook/LocalStorage";
import useTimeFormat from "../../../hook/useTimeFormat";
import { getDataCaptureDate } from "./dataCaptureDate";

Modal.setAppElement("#root");

const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgb(0 0 0 / 80%)",
    zIndex: 100,
    width: "700x",
    height: "500x",
  },
  content: {
    position: "relative",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "700px",
    height: "500",
    overflow: "hidden",
  },
  closeBtn: {
    position: "absolute",
    top: 0,
    right: "-1%",
    background: "transparent",
    border: "none",
    color: "red",
  },
};

function DataView() {
  const { formateLocalTime } = useTimeFormat();
  const { user } = LocalStorage();
  const perPage = 50;
  const { id } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [loadingSMS, setLoadingSMS] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingFollowUp, setLoadingFollowUp] = useState({});
  const [followUpMessage, setFollowUpMessage] = useState(null);
  const [dataView, setDataView] = useState([]);
  const editorRef = useRef();
  const { CKEditor, ClassicEditor } = editorRef.current || {};

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [searchKeyWordDebounce] = useDebounce(searchKeyWord, 1000);
  const [modalIsOpenEmail, setModalIsOpenEmail] = useState(false);
  const [modalIsOpenSMS, setModalIsOpenSMS] = useState(false);
  const [modalIsOpenAllSms, setModalIsOpenAllSms] = useState(false);
  const [modalIsOpenAllEmail, setModalIsOpenAllEmail] = useState(false);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  //
  const [allSelect, setAllSelect] = useState("");
  const [multipleSelect, setMultipleSelect] = useState([]);
  // send sms
  const [sendSMS, setSendSMS] = useState([]);
  const [smsMessage, setSmsMessage] = useState("");
  // send email
  const [sendEmail, setSendEmail] = useState([]);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailMessage, setEmailMessage] = useState("");

  const [smsAllMessage, setAllSmsMessage] = useState("");
  const [emailAllMessage, setAllEmailMessage] = useState("");

  const handleSelectAll = (all) => {
    setAllSelect(all);
    setIsCheckAll(!isCheckAll);
    setIsCheck(dataView && dataView.map((li) => li.id));

    if (isCheckAll) {
      setIsCheck([]);
      setAllSelect("");
    }
  };

  const handleClick = (id, itemEmailPhone) => {
    let multipleSmsEmail = [...multipleSelect, itemEmailPhone];
    setMultipleSelect(multipleSmsEmail);
    let copyItem = [...isCheck];
    let findIndx = copyItem.indexOf(parseInt(id));
    if (findIndx >= 0) {
      copyItem.splice(findIndx, 1);
      setIsCheck(copyItem);
    } else {
      copyItem = [...copyItem, parseInt(id)];
      setIsCheck(copyItem);
    }
  };

  // multiple sms/email
  const handelSelectAllSmsEmail = (itemData) => {
    if (itemData === "sms") {
      if (allSelect === "all") {
        setModalIsOpenAllSms(true);
      } else if (isCheck.length >= 1) {
        setModalIsOpenAllSms(true);
      }
    } else if (itemData === "email") {
      if (allSelect === "all") {
        setModalIsOpenAllEmail(true);
      } else if (isCheck.length >= 1) {
        setModalIsOpenAllEmail(true);
      }
    }
  };

  const sendAllSmsEmail = (status) => {
    if (status === "sms") {
      if (allSelect === "all") {
        let dataAllSms = {
          message: "smsAllMessage All",
          select_type: "all",
          type: "sms",
          event_id: id,
        };
      } else if (isCheck.length >= 1) {
        setModalIsOpenAllSms(true);
        let dataMultipleSms = {
          mobile: multipleSelect.map((value) => {
            return value.mobile;
          }),
          message: smsAllMessage,
          select_type: "multiple",
          type: "sms",
          event_id: id,
        };
      }
    } else if (status === "email") {
      if (allSelect === "all") {
        let dataAllEmail = {
          subject: emailSubject,
          message: emailAllMessage,
          select_type: "all",
          type: "email",
          event_id: id,
        };
        setLoadingEmail(true);
        http.post("leads/bulk/sms-email", dataAllEmail).then((res) => {
          if (res.data.status === "success") {
            setLoadingEmail(false);
            setEmailSubject("");
            setAllEmailMessage("");
            setModalIsOpenAllEmail(false);
          }
        });
      } else if (isCheck.length >= 1) {
        setModalIsOpenAllEmail(true);
        let dataMultipleEmail = {
          email: multipleSelect.map((value) => {
            return value.email;
          }),
          subject: emailSubject,
          message: emailAllMessage,
          select_type: "multiple",
          type: "email",
          event_id: id,
        };
        setLoadingEmail(true);
        http.post("leads/bulk/sms-email", dataMultipleEmail).then((res) => {
          if (res.data.status === "success") {
            setLoadingEmail(false);
            setEmailSubject("");
            setAllEmailMessage("");
            setModalIsOpenAllEmail(false);
          }
        });
      }
    }
  };

  // single sms start
  const singleSendSMS = (itemSms) => {
    let mobileArray = {
      phone: itemSms.mobile,
    };
    let isCheckID = isCheck.filter((ids) => ids === itemSms.id);
    if (isCheckID[0] === isCheck[0]) {
      setSendSMS(Object.values(mobileArray));
      setModalIsOpenSMS(true);
    }
  };

  const sendSMSToCustomer = () => {
    let dataSms = {
      mobile: sendSMS,
      message: smsMessage,
      select_type: "single",
      type: "sms",
      event_id: id,
    };
    console.log("send SMS single", dataSms);
  };
  // single sms end

  // single email start
  const singleSendEmail = (itemEmail) => {
    let emailArray = {
      email: itemEmail.email,
    };
    let isCheckID = isCheck.filter((ids) => ids === itemEmail.id);
    if (isCheckID[0] === isCheck[0]) {
      setSendEmail(Object.values(emailArray));
      setModalIsOpenEmail(true);
    }
  };

  const sendEmailToCustomer = () => {
    let dataEmail = {
      email: sendEmail,
      subject: emailSubject,
      message: emailMessage,
      select_type: "single",
      type: "email",
      event_id: id,
    };
    try {
      setLoadingEmail(true);
      http.post("leads/bulk/sms-email", dataEmail).then((res) => {
        if (res.data.status === "success") {
          setLoadingEmail(false);
          setEmailSubject("");
          setEmailMessage("");
          setModalIsOpenEmail(false);
        }
      });
    } catch (error) {}
  };
  // single email end

  const handleSearch = (query) => {
    setSearchKeyWord(query);
  };

  const fetchDataView = async (params) => {
    try {
      setLoading(true);
      await http
        .get(`data-capture-events-view/${id}`, { params })
        .then((res) => {
          setTotalPages(res?.data?.event?.last_page || 1);
          setDataView([...dataView, ...res.data.event.data]);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = {
      per_page: perPage,
      page: currentPage,
      search: searchKeyWordDebounce,
    };
    fetchDataView(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKeyWordDebounce, currentPage]);

  useEffect(() => {
    editorRef.current = {
      // CKEditor: require('@ckeditor/ckeditor5-react'), // depricated in v3
      CKEditor: require("@ckeditor/ckeditor5-react").CKEditor,
      ClassicEditor: require("@ckeditor/ckeditor5-build-classic"),
    };
  }, []);

  const downloadCsv = (uuid) => {
    window.open(`${downloadUrl}export-data-capture/${uuid}`);
  };

  const sendFollowUpNow = async (item) => {
    setLoadingFollowUp((prev) => ({ ...prev, [item.id]: true }));
    try {
      const res = await http.post("leads/send-followup", {
        mobile: item.mobile,
        event_id: id,
      });
      if (res.data === "success") {
        setFollowUpMessage({ type: "success", text: "Follow up message sent" });
      } else {
        setFollowUpMessage({ type: "error", text: "Failed to send follow-up" });
      }
    } catch (error) {
      setFollowUpMessage({ type: "error", text: "Failed to send follow-up" });
    } finally {
      setLoadingFollowUp((prev) => ({ ...prev, [item.id]: false }));
      setTimeout(() => setFollowUpMessage(null), 3000);
    }
  };

  return (
    <div className="data-capture-table">
      {followUpMessage && (
        <div
          className={`alert ${
            followUpMessage.type === "success" ? "alert-success" : "alert-danger"
          } text-center`}
          role="alert"
        >
          {followUpMessage.text}
        </div>
      )}
      <TableFilter>
        <TableSearch
          value={searchKeyWord}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </TableFilter>
      <div className="my-3 text-center">
        <button
          type="button"
          onClick={handelSelectAllSmsEmail.bind(this, "sms")}
          className="mr-2 btn btn-primary btn-sm"
        >
          {allSelect === "all"
            ? "Send All SMS"
            : isCheck.length <= 1
            ? "Send All SMS "
            : "Send Marked SMS"}
        </button>
        <button
          type="button"
          onClick={handelSelectAllSmsEmail.bind(this, "email")}
          className="mr-2 btn btn-primary btn-sm"
        >
          {allSelect === "all"
            ? "Send All Email"
            : isCheck.length <= 1
            ? "Send All Email"
            : "Send Marked Email"}
        </button>
        <button
          type="button"
          onClick={downloadCsv.bind(this, location?.state?.uuid)}
          className="mr-2 btn btn-primary btn-sm"
        >
          Export CSV
        </button>
      </div>
      <Table>
        <TableHeader>
          <tr className="p-3">
            <th>
              <Checkbox
                type="checkbox"
                name="selectAll"
                id="selectAll"
                handleClick={handleSelectAll.bind(this, "all")}
                isChecked={isCheckAll}
              />
            </th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            {/* <th>Suburb</th>
            <th>Favorite Drinks</th> */}
            <th>Captured Date &amp; Time</th>
            <th className="text-center">Send SMS/Email</th>

            {/* <th>#</th>
            <th>Form Data</th>
            <th>Captured Date &amp; Time</th> */}
            {/* <th className="text-center">Send SMS/Email</th> */}
          </tr>
        </TableHeader>
        <TableBody>
          {loading && dataView.length === 0 ? (
            <tr>
              <td colSpan={8}>
                <div className="my-5 text-center col-md-12">
                  <span
                    className="spinner-border"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </div>
              </td>
            </tr>
          ) : (
            dataView &&
            dataView.map((item, index) => {
              return (
                <tr key={item.id}>
                  <td>
                    <Checkbox
                      type="checkbox"
                      name={item.id}
                      id={item.id}
                      handleClick={handleClick.bind(this, item.id, item)}
                      isChecked={isCheck.includes(item.id)}
                    />
                  </td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.mobile}</td>
                  <td>{formateLocalTime(getDataCaptureDate(item))}</td>
                  <td className="text-center">
                    <button
                      type="button"
                      disabled={
                        allSelect === "all"
                          ? true
                          : isCheck.length <= 1
                          ? false
                          : true
                      }
                      onClick={singleSendSMS.bind(this, item)}
                      className="ml-2 btn btn-primary btn-sm radius-10"
                    >
                      Send SMS
                    </button>
                    <button
                      type="button"
                      disabled={
                        allSelect === "all"
                          ? true
                          : isCheck.length <= 1
                          ? false
                          : true
                      }
                      onClick={singleSendEmail.bind(this, item)}
                      className="ml-2 btn btn-primary btn-sm radius-10"
                    >
                      Send Email
                    </button>
                    {user?.id === 43 && (
                      <button
                        type="button"
                        disabled={loadingFollowUp[item.id]}
                        onClick={() => sendFollowUpNow(item)}
                        className="ml-2 btn btn-warning btn-sm radius-10"
                      >
                        {loadingFollowUp[item.id] ? "Sending..." : "Send Follow-up Now"}
                      </button>
                    )}
                  </td>
                </tr>
              );
            })
          )}
          {loading && dataView.length > 0 && (
            <tr>
              <td colSpan={8}>
                <div className="my-3 text-center col-md-12">
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </div>
              </td>
            </tr>
          )}
          <div className="clearfix"></div>
        </TableBody>
      </Table>
      <div className="text-center">
        {currentPage < totalPages && (
          <button
            className="text-center btn btn-primary"
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        )}
      </div>
      {/* <h1>hello</h1> */}
      {/* <TablePagination
        currentPage={dataView.current_page}
        total={dataView.total}
        perPage={5}
        from={dataView.from}
        to={dataView.to}
        onChange={(page) => setCurrentPage(page)}
      /> */}

      {/* Modal for SMS */}
      <Modal
        isOpen={modalIsOpenSMS}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <form action="">
                <div className="form-group">
                  <label htmlFor="">Enter Phone</label>
                  <input
                    type="number"
                    value={sendSMS[0]}
                    readOnly
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="">Message</label>
                  <textarea
                    defaultValue={smsMessage}
                    onChange={(e) => setSmsMessage(e.target.value)}
                    className="form-control"
                    id=""
                    cols="30"
                    rows="10"
                  ></textarea>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="mr-2 btn btn-primary"
                    onClick={() => setModalIsOpenSMS(false)}
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={sendSMSToCustomer}
                  >
                    {" "}
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>

      {/* Modal for Email */}
      <Modal
        isOpen={modalIsOpenEmail}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <form action="">
                <div className="form-group">
                  <label htmlFor="">Email Subject</label>
                  <input
                    type="text"
                    defaultValue={emailSubject}
                    onChange={(e) => setEmailSubject(e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="">Message</label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={emailMessage}
                    config={{
                      // plugins: [ 'EasyImage' ],
                      toolbar: {
                        items: [
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "link",
                          "|",
                          "bulletedList",
                          "numberedList",
                          "|",
                          "uploadImage",
                          "insertImage",
                          "easyImage",
                          "blockQuote",
                          "insertTable",
                          "mediaEmbed",
                          "toggleImageCaption",
                          "imageTextAlternative",
                          "|",
                          "",
                          "|",
                          "undo",
                          "redo",
                        ],
                      },
                    }}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "300px",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setEmailMessage(data);
                    }}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="mr-2 btn btn-primary"
                    onClick={() => setModalIsOpenEmail(false)}
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={sendEmailToCustomer}
                  >
                    {loadingEmail ? (
                      <LoadingSpinner
                        color="text-white"
                        className="spinner-grow-sm"
                      />
                    ) : (
                      "Send"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>

      {/* Modal for AllSMSl */}
      <Modal
        isOpen={modalIsOpenAllSms}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="">Message SMS</label>
                <textarea
                  defaultValue={smsAllMessage}
                  onChange={(e) => setAllSmsMessage(e.target.value)}
                  className="form-control"
                  id=""
                  cols="30"
                  rows="10"
                ></textarea>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="mr-2 btn btn-primary"
                  onClick={() => setModalIsOpenAllSms(false)}
                >
                  {" "}
                  Cancel{" "}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={sendAllSmsEmail.bind(this, "sms")}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* Modal for AllEmail */}
      <Modal
        isOpen={modalIsOpenAllEmail}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <form action="">
                <div className="form-group">
                  <label htmlFor="">Email Subject</label>
                  <input
                    type="text"
                    defaultValue={emailSubject}
                    onChange={(e) => setEmailSubject(e.target.value)}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="">Message Email</label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={emailAllMessage}
                    config={{
                      // plugins: [ 'EasyImage' ],
                      toolbar: {
                        items: [
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "link",
                          "|",
                          "bulletedList",
                          "numberedList",
                          "|",
                          "uploadImage",
                          "insertImage",
                          "easyImage",
                          "blockQuote",
                          "insertTable",
                          "mediaEmbed",
                          "toggleImageCaption",
                          "imageTextAlternative",
                          "|",
                          "",
                          "|",
                          "undo",
                          "redo",
                        ],
                      },
                    }}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height",
                          "300px",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setAllEmailMessage(data);
                    }}
                  />
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="mr-2 btn btn-primary"
                    onClick={() => setModalIsOpenAllEmail(false)}
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={sendAllSmsEmail.bind(this, "email")}
                  >
                    {loadingEmail ? (
                      <LoadingSpinner
                        color="text-white"
                        className="spinner-grow-sm"
                      />
                    ) : (
                      "Send"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default DataView;
